module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "licenseHistory"
  }, [_c('el-form', {
    ref: "licenseHistoryNumForm",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.licenseHistoryNumForm,
      "rules": _vm.searchRules
    }
  }, [_c('h1', [_vm._v("License History")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "option"
    }
  }, [_c('el-cascader', {
    ref: "eventCascader",
    attrs: {
      "options": _vm.options,
      "show-all-levels": false,
      "placeholder": "Select Event Type"
    },
    on: {
      "change": _vm.elCascaderOnlick
    },
    model: {
      value: (_vm.licenseHistoryNumForm.option),
      callback: function($$v) {
        _vm.$set(_vm.licenseHistoryNumForm, "option", $$v)
      },
      expression: "licenseHistoryNumForm.option"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "number"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOuterLicenseInput),
      expression: "showOuterLicenseInput"
    }],
    attrs: {
      "placeholder": _vm.licenseHistoryInputPlaceHolder
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.licenseHistoryNumForm.number),
      callback: function($$v) {
        _vm.$set(_vm.licenseHistoryNumForm, "number", $$v)
      },
      expression: "licenseHistoryNumForm.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOuterLicenseInput),
      expression: "showOuterLicenseInput"
    }],
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.searching
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLicenseUpload),
      expression: "showLicenseUpload"
    }],
    ref: "upload",
    staticClass: "upload-license",
    attrs: {
      "drag": "",
      "action": "uploadLicenceRequest",
      "multiple": false,
      "limit": 1,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "on-exceed": _vm.handleUploadExceed,
      "http-request": _vm.uploadLicenceRequest
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Drag file to here or "), _c('em', [_vm._v("Click to upload file")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Please upload the .lic file")])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLicenseHistoryRecord),
      expression: "showLicenseHistoryRecord"
    }],
    staticStyle: {
      "float": "right",
      "color": "red"
    }
  }, [_vm._v("\n        *Deleted Record will be highlighted\n      ")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLicenseHistoryRecord),
      expression: "showLicenseHistoryRecord"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.searching),
      expression: "searching"
    }],
    ref: "filterTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.licenseHistoryData,
      "row-class-name": _vm.tableRowClassName,
      "header-cell-style": {
        textAlign: 'center',
        background: '#E5E7E9'
      },
      "cell-style": {
        textAlign: 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "er_num",
      "label": "ER Number",
      "min-width": "95",
      "sortable": "",
      "sort-orders": ['ascending', 'descending'],
      "formatter": _vm.arrayFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content.outerlicense",
      "label": "Outer License ID",
      "min-width": "95",
      "sortable": "",
      "sort-orders": ['ascending', 'descending']
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content.interlicense",
      "label": "Inter License ID",
      "min-width": "90",
      "sortable": "",
      "sort-orders": ['ascending', 'descending']
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content.project",
      "label": "Project Name",
      "min-width": "90",
      "sortable": "",
      "sort-orders": ['ascending', 'descending']
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "timestamp",
      "label": "Timestamp [as UTC(+00:00)]",
      "formatter": _vm.dateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content.direct_cus",
      "label": "Direct Customer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content.ne_point",
      "label": "Ne Point"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content.exp_date",
      "label": "Expiry Date [as UTC(+00:00)]",
      "formatter": _vm.contentDateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content.license_content",
      "label": "License Content",
      "formatter": _vm.jsonFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content.user_email",
      "label": "Customer Email"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLicenseHistoryRecord),
      expression: "showLicenseHistoryRecord"
    }],
    attrs: {
      "current-page": _vm.curPage,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.numOfData
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7369ad","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LicenseHistory.vue
// module id = seH1
// module chunks = 1